import React from 'react';
import {  Popper, Fade, Paper, Typography, Divider } from '@mui/material';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import EmailIcon from '@mui/icons-material/Email';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import theme from 'core/layouts/theme';

const UserPopper = ({user, openPopper, anchorEl, onClickAway}) => {
  // const theme = useTheme();
  const {displayName, mobile, email} = user || {};
  // console.log('theme.palette.dark', openPopper)
  function getRow(icon, value) {
    return (
    <Typography sx={{ px: 2, py: .5 }} variant="body2" gutterBottom>
      {icon} {value}
    </Typography>)
  }
  return (
    <ClickAwayListener onClickAway={onClickAway} mouseEvent="onMouseDown"
    touchEvent="onTouchStart">
      <Popper
        open={openPopper}
        anchorEl={anchorEl}
        placement="bottom"
        transition
        sx={{ position: 'relative'}}
        // modifiers={[
        //   {
        //     name: 'arrow',
        //     enabled: true,
        //     options: {
        //       // element: arrowRef,
        //     },
        //   }
        // ]}
        >
      {({ TransitionProps }) => (
        <Fade {...TransitionProps} timeout={350}>
          <Paper sx={{pb: 2}}>
            <Typography sx={{ px: 2, py: 1, color:'#fff', backgroundColor: theme.palette.primary.darker }} variant="subtitle1">User details</Typography>
            <Divider />
            <Typography sx={{ px: 2, py: 1}} variant="subtitle2" gutterBottom>Details of the user that booked this seat</Typography>
            {getRow(<AccountCircleIcon sx={{verticalAlign: "middle"}}/>,displayName)}
            {getRow(<EmailIcon sx={{verticalAlign: "middle"}} />,email)}
            {getRow(<LocalPhoneIcon sx={{verticalAlign: "middle"}} />,mobile)}
          </Paper>
        </Fade>
      )}
    </Popper>
    </ClickAwayListener>
  );
}
 
export default React.memo(UserPopper);
